var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { styled } from '@mui/material';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
export var COLORS = {
    gradient: 'linear-gradient(98deg, rgb(198, 167, 254), rgb(145, 85, 253) 94%)',
    inactive: '#e8e8e8',
    inactiveText: '#666',
    connectorInactive: '#e0e0e0',
    white: '#fff',
    shadow: 'rgba(145, 85, 253, 0.3)',
};
export var SIZES = {
    iconSize: 24,
    stepIconSize: 50,
    connectorHeight: 3,
    connectorBorderRadius: 2,
    connectorTop: 25,
};
export var styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: 4,
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        backfaceVisibility: 'hidden',
        transform: 'translateZ(0)',
        position: 'relative',
        zIndex: 1000,
        contain: 'layout style',
        isolation: 'isolate',
        // Override any parent positioning
        '& *': {
            boxSizing: 'border-box',
        },
        // Ensure stepper gets proper positioning context
        '& .MuiStepper-root': {
            position: 'relative !important',
            overflow: 'visible !important',
        },
    },
};
export var iconStyles = {
    fontSize: SIZES.iconSize,
    filter: 'drop-shadow(0 0 0 currentColor)',
    WebkitFontSmoothing: 'antialiased',
};
export var connectorStyles = function (theme) {
    var _a, _b, _c;
    return (_a = {},
        _a["&.".concat(stepConnectorClasses.alternativeLabel)] = {
            top: SIZES.connectorTop,
        },
        _a["&.".concat(stepConnectorClasses.active)] = (_b = {},
            _b["& .".concat(stepConnectorClasses.line)] = {
                backgroundImage: COLORS.gradient,
            },
            _b),
        _a["&.".concat(stepConnectorClasses.completed)] = (_c = {},
            _c["& .".concat(stepConnectorClasses.line)] = {
                backgroundImage: COLORS.gradient,
            },
            _c),
        _a["& .".concat(stepConnectorClasses.line)] = __assign({ height: SIZES.connectorHeight, border: 0, backgroundColor: COLORS.connectorInactive, borderRadius: SIZES.connectorBorderRadius, transition: 'all 0.3s ease' }, theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        })),
        _a);
};
export var ColorlibConnector = styled(StepConnector)(function () { return ({
    // Force connector visibility and positioning with maximum specificity
    '&.MuiStepConnector-root.MuiStepConnector-horizontal': {
        position: 'absolute !important',
        top: "".concat(SIZES.connectorTop, "px !important"),
        left: 'calc(-50% + 20px) !important',
        right: 'calc(50% + 20px) !important',
        zIndex: '0 !important',
        margin: '0 !important',
        padding: '0 !important',
        transform: 'none !important',
        display: 'block !important',
        visibility: 'visible !important',
        opacity: '1 !important',
        '& .MuiStepConnector-line.MuiStepConnector-lineHorizontal': {
            height: "".concat(SIZES.connectorHeight, "px !important"),
            border: '0 !important',
            backgroundColor: "".concat(COLORS.connectorInactive, " !important"),
            borderRadius: "".concat(SIZES.connectorBorderRadius, "px !important"),
            margin: '0 !important',
            padding: '0 !important',
            position: 'relative !important',
            top: '0 !important',
            left: '0 !important',
            right: '0 !important',
            bottom: '0 !important',
            transform: 'none !important',
            minHeight: "".concat(SIZES.connectorHeight, "px !important"),
            maxHeight: "".concat(SIZES.connectorHeight, "px !important"),
            width: '100% !important',
            display: 'block !important',
            visibility: 'visible !important',
            opacity: '1 !important',
            flex: 'none !important',
        },
    },
    // Completed step connectors
    '&.MuiStepConnector-root.MuiStepConnector-horizontal.Mui-completed .MuiStepConnector-line': {
        backgroundImage: "".concat(COLORS.gradient, " !important"),
        backgroundColor: 'transparent !important',
    },
}); });
